import { Inbox } from "lucide-react";

export function EmptyState({
  title,
  hint,
  icon: Icon = Inbox,
}: {
  title: string;
  hint?: string;
  icon?: typeof Inbox;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12 px-6 text-muted">
      <Icon className="h-7 w-7 mb-3 opacity-60" />
      <div className="text-sm font-medium text-fg/80">{title}</div>
      {hint ? <div className="text-xs mt-1 max-w-md">{hint}</div> : null}
    </div>
  );
}
